// Save API token
export const saveApiToken = (token: string) => {
    localStorage.setItem('apiToken', token);
  };
  
// Retrieve API token
export const getApiToken = (): string | null => {
    return localStorage.getItem('apiToken');
  };
  
// Remove API token
export const removeApiToken = () => {
    localStorage.removeItem('apiToken');
  };
  
// Save user object
export const saveCurrentUser = (user: object) => {
    localStorage.setItem('currentUser', JSON.stringify(user));
  };
  
// Retrieve user object
export const getCurrentUser = (): object | null => {
    const user = localStorage.getItem('currentUser');
    return user ? JSON.parse(user) : null;
  };
  
// Remove user object
export const removeCurrentUser = () => {
    localStorage.removeItem('currentUser');
  };